/* eslint-disable max-len */
export const ptBR = {
  all: "Todos",
  auth: {
    account_merge_required: "Account merge required",
    errors: {
      email_already_in_use: "Este email já está em uso",
      invalid_email: "Email inválido",
      popup_blocked: "Popup blocked",
      too_many_requests: "Too many requests",
      user_disabled: "User disabled",
      user_not_found: "User not found",
      weak_password: "Senha muito fraca",
    },
    login_with_apple: "Login with apple",
    login_with_facebook: "Login with facebook",
    login_with_google: "Login with google",
    password_reset_sent: "Password reset sent",
  },
  common: {
    close_modal: "Fechar modal",
  },
  company: {
    load_error: "Load error",
  },
  company_info: {
    closed_now: "Fechado agora",
    more_info: "Mais informações",
    open_now: "Aberto agora",
  },
  dashboard: {
    bookings: {
      actions: {
        cancel: "Cancel",
        confirm: "Confirmar",
        deny: "Negar",
        edit: "Editar",
        view: "View",
      },
      bulk: {
        cancel: "Cancel",
        confirm: "Confirm",
        selected: "Selected",
      },
      bulk_update_fail: "Bulk update fail",
      bulk_update_partial_fail: "Bulk update partial fail",
      cancel: "Cancel",
      cancel_booking: "Cancel booking",
      cancel_fail: "Não pudemos cancelar sua reserva, tente novamente",
      choose_time: "Escolha um horário",
      columns: {
        actions: "Ações",
        customer_email: "E - mail do cliente",
        customer_name: "Nome do Cliente",
        datetime: "Data da Reserva",
        seats: "Assentos",
        status: "Status",
      },
      concierge: {
        back: "Voltar",
        booked: "Reservado em",
        camera_error: "Camera error",
        camera_generic_error: "Camera generic error",
        camera_not_found: "Camera not found",
        camera_permission_denied: "Camera permission denied",
        closereader: "Feche o leitor",
        cod: "Codigo",
        confirm: "Confirmar reserva",
        confirmed: "Pessoas confirmadas",
        contact: "Alguma dúvida ? Entre em contato com o gerente ou administrador.",
        hello: "Olá Sr.Concierge!",
        is_invalid: "Essa reserva está fora do seu periodo de uso.",
        last_scan_id: "id: {{booking_id}}",
        loading: "Carregando dados da reserva...",
        mail: "E - mail",
        name: "Nome",
        not_found: "Reserva não encontrada",
        openreader: "Abra o leitor",
        phone: "Telefone",
        recomendation: "Por favor leia outro QRCODE e tente novamente!",
        remain: "Restam",
        scancode: "Lendo QrCode da Reserva",
        scanned: "Reserva lida",
        seatsfor: "Assentos para",
        state: "Estado",
        switch_camera: "Trocar Câmera",
        usereader: "Use o leitor abaixo para ler o código de reserva.",
      },
      created_at: "Created at",
      created_fail: "Não pudemos criar uma nova reserva, tente novamente.",
      created_success: "Nova reserva criada!",
      customer: {
        bookings: "Suas reservas",
        complete: "Perfil completo",
        email: "Nós enviamos um email de confirmação, cheque sua caixa de entrada.",
        menu: "Menu",
        none: "Você não tem nenhuma reserva.",
        profile_updated: "Perfil atualizado com sucesso!",
        qr_info: "Sua reserva foi enviada ao seu email, mas também pode ser vista clicando em 'Ver QRCode'.",
        qr_modal_description: "Mostre este QRCode no restaurante para confirmar sua reserva.",
        qr_modal_title: "QRCode da Reserva",
        title: "Reservas",
        view_qr: "Ver QRCode",
      },
      delete_success: "Reserva Cancelada!",
      dialogs: {
        confirmed: {
          message: "Deseja confirmar reserva para '{{booking_title}}' assentos ? ",
          success: "Reserva confirmada!.",
          title: "Confirmar reservas",
        },
        edit: "Editar reserva",
        fail: {
          message: "Alguma coisa deu errado quando tentamos confirmar esta reserva, tente novamente!!",
          title: "Ops!",
        },
      },
      edit_booking: "Edit booking",
      empty_suggestion: "Empty suggestion",
      filters: {
        all_status: "All status",
        date: "Date",
        date_range: "Date range",
        filters: "Filtros",
        search: "Busca",
        search_placeholder: "Buscar reservas...",
        status: "Status da Reserva",
      },
      final_status: "O status desta reserva não pode mais ser alterada.",
      how_many: "Mesa para quantas pessoas?",
      load_error: "Load error",
      no_availability: "No availability",
      no_bookings_concierge: "No bookings concierge",
      no_bookings_customer: "No bookings customer",
      no_date: "Não foi possível carregar as informações disponíveis para a data selecionada, selecione outra data e tente novamente.",
      notes: "Notes",
      people_count: "People count",
      refresh_error: "Refresh error",
      reservation: "Reservation",
      showing_count: "Showing count",
      status: {
        all: "All",
        canceled: "Cancelada",
        cancelled: "Cancelled",
        completed: "Completed",
        confirmed: "Confirmada",
        created: "Aguardando confirmação",
        denied: "Negada",
        noshow: "Não compareceu",
        partial: "Aguardando chegada de clientes ",
        pending: "Pending",
        used: "Já utilizada",
      },
      status_error: "Status error",
      status_label: "Status label",
      table: {
        actions: "Actions",
        customer: "Customer",
        datetime: "Datetime",
        id: "Id",
        seats: "Seats",
        status: "Status",
      },
      title: "Lista de Reservas",
      total_count: "Total count",
      update_fail: "Update fail",
      weekdays: {
        friday: "Sex",
        monday: "Seg",
        saturday: "Sab",
        sunday: "Dom",
        thursday: "Qui",
        tuesday: "Ter",
        wednesday: "Qua",
      },
    },
    categories: {
      actions: {
        delete: "Apagar",
        disable: "Desabilitar",
        edit: "Editar",
        enable: "Habilitar",
      },
      columns: {
        actions: "Ações",
        description: "Descrição",
        langs: "Idiomas Cadastrados",
        name: "Nome",
        order: "Ordem",
        status: "Status",
      },
      dialogs: {
        delete: {
          message: "Você quer realmente apagar a categoria '{{category_name}}' ?",
          title: "Apagar categoria",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        all_languages_required: "Todos os idiomas são obrigatórios",
        basic_info: "Informações Básicas",
        create_title: "Nova Categoria",
        edit_title: "Editar Categoria",
        description: "Descrição",
        enabled: "Habilitar",
        name: "Nome da Categoria",
        order: "Ordem",
        order_placeholder: "1",
        texts: "Informações da Categoria",
      },
      new: "Nova categoria",
      not_found: "Categoria não encontrada, por favor tente novamente!",
      status: {
        disabled: "Desabilitado",
        enabled: "Habilitado",
      },
      title: "Lista de Categorias",
    },
    clear_filter: "Limpar busca e filtros",
    company: {
      booking_title: "Reservas",
      bookings_title: "Horário de Reservas",
      colors_title: "Cores e Estilos",
      disclaimers_title: "Avisos Legais do Menu",
      form: {
        booking_approval: "Aprovar reservas",
        booking_interval: "Intervalo entre reservas",
        booking_max_seats: "Quantidade máxima de assentos",
        booking_toleration: "Tolerância da reserva",
        currency: "Moeda",
        end: "Horário Final",
        lang: "Idioma Padrão",
        langs: "Idiomas Disponíveis",
        name: "Nome",
        period: "Periodo",
        phone: "Número de Telefone",
        pics: "Itens com Foto",
        qrcode_bg: "Cor de Fundo do QR Code",
        qrcode_border: "Cor da Borda do QR Code",
        required: "Campo obrigatório",
        seats: "Assentos",
        start: "Horário Inicial",
        street_address: "Endereço",
        theme: "Cor do Tema",
        timezone: "Fuso Horário da Empresa",
        weekday: "Dia da semana",
      },
      periods_title: "Horário do Cardápio",
      request_error: "Não foi possível carregar as informações da empresa",
      runnings_title: "Horário de Funcionamento",
      time_title: "Informações de Fuso horário",
      title: "Empresa",
    },
    discounts: {
      columns: {
        actions: "Ações",
        items: "Items",
        name: "Nome",
        percent: "Percentual %",
        period: "Periodo",
        type: "Tipo",
      },
      dialogs: {
        delete: {
          message: "Você quer realmente apagar o desconto '{{discount_name}}' ?",
          title: "Apagar desconto",
        },
      },
      enabled: "Habilitado",
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        apply_to: "Aplicar a",
        basic_info: "Informações Básicas",
        discount_info: "Informações do Desconto",
        percent_placeholder: "0",
      },
      items: "Itens (Comidas / Categorias)",
      name: "Nome",
      new: "Novo desconto",
      not_found: "Desconto não encontrado, por favor selecione outro e tente novamente!",
      percent: "Percentual %",
      period: "Periodo",
      title: "Descontos",
      type: "Tipo",
      types: {
        category: "Categoria",
        food: "Comida",
      },
    },
    filters: {
      chips_label: "Chips de filtros ativos",
      expand_label: "Expandir filtros",
      summary_label: "Resumo de filtros ativos",
    },
    foods: {
      actions: {
        delete: "Apagar",
        disable: "Desabilitar",
        edit: "Editar",
        enable: "Habilitar",
        price: "Editar Preço",
      },
      card: {
        available_days_label: "Dias disponíveis",
        available_periods_label: "Períodos disponíveis",
        categories_label: "Categorias",
        featured_label: "Destaque",
        featured_tooltip: "Item em destaque",
        has_image_label: "Possui imagem",
        has_image_tooltip: "Item possui imagem",
        indicators_label: "Indicadores do item",
        original_price_label: "Preço original",
        price_label: "Preço",
        promo_price_label: "Preço promocional",
        quick_actions_label: "Ações rápidas",
        status_badges_label: "Badges de status",
      },
      columns: {
        actions: "Ações",
        categories: "Categoria",
        langs: "Idiomas Cadastrados",
        name: "Nome",
        periods: "Periodos",
        price: "Preço",
        status: "Status",
        weekdays: "Dias da Semana",
      },
      dialogs: {
        delete: {
          message: "Você realmente quer apagar o item '{{food_name}}' ?",
          title: "Apagar Item",
        },
        disable: {
          message: "Você realmente quer desabilitar o item '{{food_name}}' ?",
          title: "Desabilitar Item",
        },
        enable: {
          message: "Você realmente quer habilitar o item '{{food_name}}' ?",
          title: "Habilitar Item",
        },
        price: "Editar Preço",
      },
      drag_warning: "Selecione exatamente uma categoria para ordenar arrastando os itens",
      featured: {
        all: "All",
        featured: "Featured",
        not_featured: "Not featured",
      },
      filters: {
        availability: "Availability",
        categories: "Categorias",
        classification: "Classification",
        featured: "Destacado",
        filter_active: "filtro ativo",
        filters_active: "filtros ativos",
        inclusive: "Inclusive",
        periods: "Períodos do dia",
        preview: "Ver cardápio",
        search: "Busca",
        search_text: "Search text",
        status: "Item Status",
        weekdays: "Dias da Semana",
      },
      form: {
        all_days: "Todos os dias",
        all_languages_required: "Todos os idiomas são obrigatórios",
        all_periods: "Todos os períodos",
        availability: "Disponibilidade",
        basic_info: "Informações Básicas",
        categories: "Categorias",
        categorization: "Categorização",
        change_image: "Alterar imagem",
        code: "Código",
        coffee: "Café da manhã",
        create_title: "Novo Item",
        description: "Descrição",
        dine: "Jantar",
        edit_title: "Editar Item",
        enabled: "Habilitar",
        featured: "Destaque",
        friday: "Sexta-feira",
        image: "Imagem do item",
        lunch: "Almoço",
        monday: "Segunda-feira",
        name: "Nome",
        new_category: "Nova Categoria",
        new_tag: "Nova Tag",
        no_categories: "Nenhuma categoria disponível",
        no_tags: "Nenhuma tag disponível",
        order: "Ordem",
        periods: "Periodos",
        price: "Preço",
        price_label: "Preço",
        promo_price: "Preço promocional",
        promo_price_label: "Preço promocional",
        saturday: "Sábado",
        snack: "Lanche",
        sunday: "Domingo",
        tags: "Tags",
        texts: "Informações do Item",
        thursday: "Quinta-feira",
        tuesday: "Terça-feira",
        wednesday: "Quarta-feira",
        weekdays: "Dias",
      },
      grid_label: "Itens de alimentos",
      new: "Novo Item",
      not_found: "Item não encontrado, por favor selecione outro e tente novamente!",
      periods: {
        "": "",
        all: "All",
        coffee: "Coffee",
        dine: "Dine",
        lunch: "Lunch",
        snack: "Snack",
      },
      quick_filters: {
        active: "Ativos",
        featured: "Destacados",
        inactive: "Inativos",
        on_sale: "Em Promoção",
      },
      statistics: {
        disabled: "Desabilitados",
        enabled: "Habilitados",
        featured: "Destacados",
        showing: "Exibindo",
      },
      statistics_label: "Resumo de estatísticas de alimentos",
      status: {
        all: "All",
        disabled: "Desabilitado",
        enabled: "Habilitado",
      },
      title: "Lista de Itens do Cardápio",
      view: {
        grid: "Grade",
        label: "Visualização",
        table: "Tabela",
      },
      weekdays: {
        "": "",
        all: "All",
        friday: "Sexta",
        monday: "Segunda",
        saturday: "Sábado",
        sunday: "Domingo",
        thursday: "Quinta",
        tuesday: "Terça",
        wednesday: "Quarta",
      },
    },
    highlights: "Destaques",
    image: {
      error: "Alguma coisa deu errado ao enviar sua imagem, tente novamente.",
      maxsize: "Esta imagem excede o tamanho máximo permitido, envie uma imagem com tamanho máximo de 5MB.",
      remove: "Alguma coisa deu errado ao apagar sua imagem, tente novamente.",
    },
    menu: {
      bookings: "Reservas",
      categories: "Categorias",
      change_password: "Alterar Senha",
      company: "Empresa",
      discounts: "Descontos",
      foods: "Itens",
      logout: "Sair",
      print_menu: "Imprimir Cardápio",
      profile: "Perfil",
      reader: "Leitor QRCode",
      tags: "Tags",
      users: "Usuários",
    },
    no_dishes: "Não há pratos no menu hoje.",
    not_found: "Nós não achamos nenhum prato de acordo com a sua busca.",
    notifications: {
      not_supported: "Notificações não são suportadas neste navegador",
    },
    reader: {
      people_count: "Quantidade de pessoas",
    },
    search_dish: "Pesquise o seu prato",
    stats: {
      all_time: "Todos os Tempos",
      canceled: "Canceladas",
      canceled_subtitle: "Reservas canceladas",
      confirmed: "Confirmadas",
      confirmed_subtitle: "Reservas confirmadas",
      occupancy_rate: "Taxa de Ocupação",
      seats: "Assentos",
      today_bookings: "Reservas Hoje",
      today_subtitle: "Reservas para hoje",
      total_bookings: "Total de Reservas",
      used: "Utilizadas",
      used_subtitle: "Reservas utilizadas",
    },
    tags: {
      columns: {
        actions: "Ações",
        langs: "Idiomas Cadastrados",
        name: "Nome",
      },
      dialogs: {
        delete: {
          message: "Você realmente quer apagar a tag  '{{category_name}}' ?",
          title: "Apagar tag",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        all_languages_required: "Todos os idiomas são obrigatórios",
        create_title: "Nova Tag",
        edit_title: "Editar Tag",
        name: "Nome da Tag",
        texts: "Informações da Tag",
      },
      new: "Nova tag",
      not_found: "Tag não encontrada, por favor tente novamente!",
      title: "Lista de Tags",
    },
    title: "ZMenu Dashboard",
    users: {
      actions: {
        delete: "Apagar",
        edit: "Editar",
      },
      columns: {
        actions: "Ações",
        fullname: "Nome Completo",
        mail: "Email",
        scopes: "Permissões",
        username: "Nome de usuário",
      },
      dialogs: {
        delete: {
          message: "Você realmente quer apagar o usuário '{{user_name}}' ?",
          title: "Apagar usuário",
        },
      },
      filters: {
        search: "Search",
        search_placeholder: "Search placeholder",
      },
      form: {
        basic_info: "Informações Básicas",
        confirm_password: "Confirmar Senha",
        create_title: "Novo Usuário",
        edit_title: "Editar Usuário",
        fullname: "Nome Completo",
        mail: "E-mail",
        password: "Senha",
        permissions: "Permissões",
        scopes: "Permissões",
        security: "Segurança",
        username: "Nome de Usuário",
      },
      new_singular: "Novo Usuário",
      not_found: "Usuário não encontrado, por favor selecione outro e tente novamente!",
      profile: {
        change_password: "Trocar Senha",
        title: "Perfil do utilizador",
      },
      title: "Lista de usuários",
    },
    password_scores: {
      very_weak: "Muito Fraca",
      weak: "Fraca", 
      okay: "Razoável",
      good: "Boa",
      strong: "Forte",
    },
  },
  dialogs: {
    attention: "Atenção",
    cancel: "Cancelar",
    close: "Fechar",
    confirm: "Sim",
    confirmation: "Confirmar",
    edit: "Edit",
    fail: "Ops!",
    gone_wrong: "Algo deu errado, tente novamente!",
    invalid_login: "O login ou a senha digitados sãp inválidos, tente novamente",
    login_error: "Erro no login. Tente novamente.",
    not_allowed: "Esse usuário não é autorizado a usar esse módulo.",
    same_user: "Já existe uma conta registrada com o email { { email } } . Tente fazer login com esta conta, em vez de associar esta conta social.",
    submit: "Enviar",
    success: "Sucesso",
  },
  password_scores: {
    very_weak: "Muito Fraca",
    weak: "Fraca", 
    okay: "Razoável",
    good: "Boa",
    strong: "Forte",
  },
  drag_limited_to: "Arraste limitado a",
  footer: "feito com amor por ZMenu ©",
  forms: {
    common: {
      price_placeholder: "0,00",
      time_placeholder: "HH:mm",
    },
  },
  gone_wrong: "Algo deu errado, tente novamente!",
  loading: "Carregando",
  login: {
    email: "E - mail",
    facebook: "Facebook",
    google: "Google",
    password: "Senha",
    sigin_apple: "Sigin apple",
    sigin_facebook: "Login com Facebook",
    sigin_google: "Login com Google",
    signup: "Cadastre - se",
    submit: "Entrar",
    username: "Usuário",
  },
  logout: "Sair",
  module: {
    disabled: "Modulo desabilitado, contate Zmenu Team para habilita - lo.",
  },
  network: {
    back_online: "Conexão restaurada",
    offline: "Sem conexão",
    offline_error: "Erro de conexão. Verifique sua internet.",
  },
  of: "de",
  pdf: {
    categories: "Categorias",
    clear_all: "Limpar tudo",
    converting_category: "Convertendo categoria {{current}} de {{total}}...",
    description: "Selecione as categorias que deseja incluir no seu cardápio para impressão",
    download: "Baixar",
    download_success: "PDF baixado com sucesso!",
    drag_to_reorder: "Arraste para reordenar as categorias no PDF",
    food_count: "{{count}} itens",
    generate: "Gerar PDF",
    generation_error: "Erro ao gerar PDF",
    generation_success: "PDF gerado com sucesso!",
    include_prices: "Incluir preços",
    language: "Idioma",
    loading: "Carregando...",
    merging_pdfs: "Mesclando PDFs...",
    no_categories: "Nenhuma categoria disponível",
    no_categories_selected: "Selecione pelo menos uma categoria",
    options: "Opções",
    preparing_menu: "Preparando cardápio...",
    preview: "Visualizar PDF",
    preview_html: "Visualizar HTML",
    preview_html_title: "Visualização HTML",
    preview_title: "Visualização do PDF",
    select_all: "Selecionar tudo",
    selected_count: "{{count}} de {{total}} categorias selecionadas",
    settings: "Configurações do PDF",
    title: "Gerar Cardápio PDF",
  },
  signup: {
    complete: "Complete seu perfil",
    confirm_password: "Confirme a senha escolhida",
    email: "Email de contato",
    name: "Nome completo",
    password: "Escolha Sua senha",
    phone: "Telefone / Celular",
    submit: "Cadastrar",
    title: "Cadastre - se",
  },
  validation: {
    email: "Email",
    error: "Error",
    maxLength: "Max length",
    minLength: "Min length",
    pattern: "Pattern",
    phone: "Phone",
    required: "Required",
  },
};
